import { render, staticRenderFns } from "./files.vue?vue&type=template&id=03857a83&scoped=true"
import script from "./files.vue?vue&type=script&setup=true&lang=js"
export * from "./files.vue?vue&type=script&setup=true&lang=js"
import style0 from "./files.vue?vue&type=style&index=0&id=03857a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03857a83",
  null
  
)

export default component.exports